import * as ko from "knockout";
import * as $ from "jquery";
// bao migrate - module not found: import "vendor/bootstrap-switch.min";
import "bootstrap";
ko.bindingHandlers.bootstrapSwitch = {
    init: function (element, valueAccessor, allBindingsAccessor, viewModel) {
        var config = {
            onText: "Ja",
            offText: "Nein"
        };
        $.extend(config, ko.toJS(valueAccessor()));
        $(element).bootstrapSwitch(config);
        $(element).on("switchChange.bootstrapSwitch", function (event, state) {
            if (valueAccessor().checked && ko.isObservable(valueAccessor().checked)) {
                valueAccessor().checked(state);
            }
        });
    },
    update: function (element, valueAccessor, allBindings, viewModel) {
        if (valueAccessor().checked && ko.isObservable(valueAccessor().checked)) {
            $(element).bootstrapSwitch("state", valueAccessor().checked());
        }
    }
};